import { useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, ScanLine, X, XCircle } from "lucide-react";

// AFTER ONE TEST LABEL: scan it with the gun and see at once whether it opens the place it was printed for.
// Reads only — the scan answers "what is this?", nothing is moved or stamped.
export function ScanCheck({ item, onClose }) {
  const [v, setV] = useState("");
  const [res, setRes] = useState(null);
  const shelf = item.kind !== "scan" || !item.id;
  const check = async (e) => {
    e.preventDefault();
    const code = v.trim();
    if (!code) return;
    setV("");
    try {
      const { data } = await api.get("/scan/resolve", { params: { code } });
      setRes(data.kind === "location" && data.id === item.id ? { ok: true } : { ok: false, got: data.code || data.label || data.kind });
    } catch { setRes({ ok: false, got: null }); }
  };
  return (
    <div data-testid="scan-check" className="rounded-xl border-2 border-[#E0781A] bg-orange-50/60 p-3 space-y-2">
      <div className="flex items-center gap-2 text-sm font-bold">
        <ScanLine className="w-4 h-4 text-[#C76714]" />{shelf ? "Shelf label sent to the printer" : `Now scan the label you just printed — ${item.code}`}
        <button type="button" data-testid="scan-check-close" onClick={onClose} className="ml-auto p-1 text-slate-500"><X className="w-4 h-4" /></button>
      </div>
      {shelf ? (
        <p data-testid="scan-check-shelf" className="text-[12px] text-slate-600">A shelf label has no code to scan. Hold it up against the picture to check it. The scan label for the same spot carries the code.</p>
      ) : (
        <form onSubmit={check} className="flex gap-2">
          <input data-testid="scan-check-input" autoFocus value={v} onChange={(e) => setV(e.target.value)} placeholder="Scan the QR or the barcode"
            className="flex-1 h-11 rounded-lg border-[1.5px] border-slate-300 bg-white px-3 text-sm font-mono" />
          <button type="submit" data-testid="scan-check-go" className="h-11 px-4 rounded-lg bg-[#1F1F1F] text-white text-sm font-bold">Check</button>
        </form>
      )}
      {res?.ok && <p data-testid="scan-check-ok" className="flex items-center gap-1.5 text-sm font-semibold text-emerald-700"><CheckCircle2 className="w-4 h-4" />Scans right — it opens {item.code}.</p>}
      {res && !res.ok && <p data-testid="scan-check-bad" className="flex items-center gap-1.5 text-sm font-semibold text-[#B01E28]"><XCircle className="w-4 h-4" />{res.got ? `That opened ${res.got}, not ${item.code}.` : "That scan didn't open any place."} Scan it again, or print it again.</p>}
    </div>
  );
}
